// extracted by mini-css-extract-plugin
export default {"addProductSection":"style_addProductSection__Pc6j7","actionsSection":"style_actionsSection__qHP7F","formSection":"style_formSection__ZEJka"};